import type { ReactElement } from 'react';

/**
 * Render a Keep-a-Changelog markdown file (main changelog or a module's)
 * as simple formatted elements.
 */
export function formatChangelog(text: string) {
  if (!text) return null;

  const lines = text.split('\n');
  const elements: ReactElement[] = [];

  lines.forEach((line, i) => {
    if (line.startsWith('# ')) {
      // Skip main title
    } else if (line.startsWith('## [Unreleased]')) {
      // Skip unreleased
    } else if (line.startsWith('## [')) {
      const match = line.match(/## \[(.+?)\]\s*-?\s*(.*)/);
      if (match) {
        elements.push(
          <div key={i} className="mt-6 mb-2 pb-2 border-b border-gray-200">
            <span className="text-lg font-semibold text-primary">v{match[1]}</span>
            <span className="text-sm text-gray-500 ml-2">{match[2]}</span>
          </div>
        );
      }
    } else if (line.startsWith('### ')) {
      const type = line.slice(4);
      const badgeColor = type === 'Fixed' ? 'bg-yellow-100 text-yellow-800' :
        type === 'Added' ? 'bg-green-100 text-green-800' :
          type === 'Changed' ? 'bg-blue-100 text-blue-800' :
            'bg-gray-100 text-gray-800';
      elements.push(
        <span key={i} className={`inline-block px-2 py-0.5 rounded-sm text-xs font-medium mt-3 mb-2 ${badgeColor}`}>
          {type}
        </span>
      );
    } else if (line.startsWith('#### ')) {
      elements.push(<h4 key={i} className="text-sm font-semibold text-gray-700 mt-3 mb-1">{line.slice(5)}</h4>);
    } else if (line.startsWith('- ')) {
      elements.push(
        <div key={i} className="flex gap-2 text-sm text-gray-600 ml-2 mb-1">
          <span className="text-gray-400">•</span>
          <span>{line.slice(2)}</span>
        </div>
      );
    }
  });

  return elements;
}
